// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"45eb15a7","239":"7cc81208","726":"2efc1f8a","732":"4acbb619","775":"0d73a5e9","795":"329e795e","833":"c47a6577","977":"48d470da"}[chunkId] + ".chunk.js";
};